import React from "react";
import { GetContact } from "../queries/get-contact";
import { Link } from "gatsby";
import { currentLocale } from "../i18n/locale-provider";
import { cn } from "../util";
import { prependLocale } from "../i18n/prepend-locale";

const Footer = () => {
  const { ContactSection } = GetContact();
  return (
    <footer
      className={cn(
        "flex flex-col items-center gap-1 bg-white px-4 py-1 xl:flex-row xl:gap-10",
      )}
    >
      <div className={cn("flex items-center gap-2 xl:gap-10")}>
        <span className={cn("font-formula text-xs xl:text-base")}>
          {ContactSection.Street}
        </span>
        <span className={cn("font-formula text-xs xl:text-base")}>
          {ContactSection.Etage}
        </span>
        <span className={cn("font-formula text-xs xl:text-base")}>
          {ContactSection.PLZ}
        </span>
      </div>

      <a
        href={`mailto:${ContactSection.email}`}
        className={cn("font-formula hidden xl:block")}
      >
        {ContactSection.email}
      </a>
      <span className={cn("hidden flex-1 xl:block")}></span>
      <div className={cn("flex items-center gap-2 xl:gap-10")}>
        <a
          className={cn("font-formula text-xs xl:text-base")}
          href="https://www.instagram.com/thisis__agency/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Instagram
        </a>
        <Link
          to={prependLocale("/imprint/")}
          className={cn("font-formula text-xs xl:text-base")}
        >
          {currentLocale === "de" ? "Impressum" : "Imprint"}
        </Link>
        <span className={cn("font-formula text-xs")}>
          © {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
